// Theme presets (2-3) and font presets

export const THEMES = {
  classic: {
    label: "Istanbul Classic",
    description: "Warm cream & red — the current look",
    vars: {
      "--ri-cream": "#faf6ee",
      "--ri-cream-2": "#f2ece0",
      "--ri-ink": "#1a1a1a",
      "--ri-ink-soft": "#3a3835",
      "--ri-muted": "#6b675f",
      "--ri-red": "#d4321c",
      "--ri-red-dark": "#b62513",
      "--ri-border": "#e5ded0",
    },
  },
  bosphorus: {
    label: "Bosphorus Blue",
    description: "Sea-blue tones with warm amber accent",
    vars: {
      "--ri-cream": "#f4f7fa",
      "--ri-cream-2": "#e8eef4",
      "--ri-ink": "#0f2137",
      "--ri-ink-soft": "#2c405a",
      "--ri-muted": "#5f7590",
      "--ri-red": "#c47a1a",
      "--ri-red-dark": "#a1620f",
      "--ri-border": "#d5dfeb",
    },
  },
  ottoman: {
    label: "Ottoman Emerald",
    description: "Cream base with deep emerald & gold",
    vars: {
      "--ri-cream": "#f8f4ea",
      "--ri-cream-2": "#efe8d5",
      "--ri-ink": "#1f2e1c",
      "--ri-ink-soft": "#3d4f38",
      "--ri-muted": "#6d7a68",
      "--ri-red": "#1f7a54",
      "--ri-red-dark": "#155d3f",
      "--ri-border": "#e2d9c0",
    },
  },
  goldenhorn: {
    label: "Golden Horn",
    description: "Calm Bosphorus blue with warm golden accents",
    vars: {
      "--ri-cream": "#faf6ee",
      "--ri-cream-2": "#f2ece0",
      "--ri-ink": "#1a1a1a",
      "--ri-ink-soft": "#3a3835",
      "--ri-muted": "#6b675f",
      "--ri-red": "#1d6fa5",
      "--ri-red-dark": "#14536e",
      "--ri-border": "#e5ded0",
    },
  },
};

export const FONTS = {
  editorial: {
    label: "Editorial",
    description: "Playfair Display + Inter",
    display: "'Playfair Display', Georgia, serif",
    body: "'Inter', ui-sans-serif, system-ui",
    google: "family=Playfair+Display:ital,wght@0,400;0,700;0,800;1,400;1,700&family=Inter:wght@400;500;600;700",
  },
  modern: {
    label: "Modern Serif",
    description: "Cormorant Garamond + Inter",
    display: "'Cormorant Garamond', Georgia, serif",
    body: "'Inter', ui-sans-serif, system-ui",
    google: "family=Cormorant+Garamond:ital,wght@0,500;0,700;1,500&family=Inter:wght@400;500;600;700",
  },
  warm: {
    label: "Warm & Rounded",
    description: "DM Serif Display + Nunito",
    display: "'DM Serif Display', Georgia, serif",
    body: "'Nunito', ui-sans-serif, system-ui",
    google: "family=DM+Serif+Display:ital@0;1&family=Nunito:wght@400;500;600;700",
  },
};

export const applyTheme = (themeKey) => {
  const t = THEMES[themeKey] || THEMES.classic;
  const root = document.documentElement;
  Object.entries(t.vars).forEach(([k, v]) => root.style.setProperty(k, v));
};

export const applyFont = (fontKey) => {
  const f = FONTS[fontKey] || FONTS.editorial;
  // Ensure font is loaded from Google Fonts + Caveat (brand script)
  const id = "ri-google-fonts";
  const href = `https://fonts.googleapis.com/css2?${f.google}&family=Caveat:wght@600;700&display=swap`;
  let link = document.getElementById(id);
  if (!link) {
    link = document.createElement("link");
    link.id = id;
    link.rel = "stylesheet";
    document.head.appendChild(link);
  }
  if (link.href !== href) link.href = href;
  const root = document.documentElement;
  root.style.setProperty("--ri-font-display", f.display);
  root.style.setProperty("--ri-font-body", f.body);
};
